import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner  } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'


import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import DateTimePicker from 'react-widgets/lib/DateTimePicker'

import { AutoComplete as MUIAutoComplete } from 'material-ui'
import { AutoComplete, } from 'redux-form-material-ui'


const renderField = ({
    input,
    type,
    placeholder,
    label,
    disabled,
    readOnly,
    meta: { touched, error, warning },
}) => (
        <Row>
            <Col md="12">
                <Label htmlFor="{input}" className="col-form-label">
                    {label}
                </Label>
            </Col>
            <Col md="12">
                <Input
                    {...input}
                    type={type}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                ></Input>
                {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
            </Col>
        </Row>
    );

const validate = values => {
    const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;

    const errors = {}

    //--------------------------------------------------------------------------------------------------------
    const requiredFields5 = [
        'enviarcorreo'
    ]
    const requiredFields6 = [
        'tipopago'
    ]
    const requiredFields7 = [
        'facturar'
    ]
    const requiredFields8 = [
        'idcicloescolar'
    ]


    requiredFields5.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar si enviarás notificación por correo electrónico al padre de familia';
        }
    })

    requiredFields6.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar el tipo de pago';
        }
    })

    requiredFields7.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar si requiere facturar o no';
        }
    })

    requiredFields8.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar el ciclo escolar';
        }
    })


    if (!values.ajuste || values.ajuste === "") {
        errors.ajuste = "Debes ingresar ajuste";
    }


    if (!pattern.test(values.correotutor)) {
        errors.correotutor = 'Correo con formato invalido';
    }

    if (values.facturar === "SI") {
        if (values.rfc == "") {
            errors.rfc = "Debes ingresar el RFC para poder realizar la factura";
        }
    }



    //--------------------------------------------------------------------------------------------------------

    return errors
}

const renderFromHelper = ({ touched, error }) => {
    if (!(touched && error)) {
        return
    } else {
        return <FormHelperText>{touched && error}</FormHelperText>
    }
}


const renderSelectField5 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Enviar Correo</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'enviarcorreo',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField6 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Tipo Pago</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'tipopago',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )
const renderSelectField7 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Facturar</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'facturar',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField8 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Ciclo Escolar</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'idcicloescolar',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )


const renderDateTimePicker = ({ input: { onChange, value }, showTime }) =>
    <DateTimePicker
        onChange={onChange}
        format="yyyy/MM/dd"
        time={showTime}
        value={!value ? null : new Date(value)}
    />


const mapStateToProps = (state) => {

    
    const Alumno = Object.values(state.AlumnoReducer.getAlumnoDetail);

    let idtutor                 = "";
    let apellidopaterno         = "";
    let apellidomaterno         = "";
    let nombres                 = "";
    let sexo                    = "";   //Femenino,Masculino
    let fechanacimiento         = "";
    let estadonacimiento        = "";
    let discapacidad            = "";   //SI,NO
    let discapacidaddescripcion = "";   //Autismo, Baja Vision, Ceguera, Discapacidad Intelectual, Discapacidad Multiple, Hipoacusia, Otra
    let otra                    = "";
    let aptitud                 = "";   //NO,SI
    let aptituddescripcion      = "";
    let calle                   = "";
    let numero                  = "";
    let colonia                 = "";
    let municipio               = "";
    let codigopostal            = "";
    let telefono                = "";
    let nivel                   = "";   //Kinder,Preparatoria,Primaria,Secundaria
    let nivel2                  = "";   //1,2,3,4,5,6
    let grupo                   = "";   //A,B,C
    let turno                   = "";   
    let nombretutor             = "";
    let ajuste                  = "0";
    let enviarcorreo            = "";
    let tipopago                = "";
    let correotutor             = "";
    let facturar                = "";
    let rfc                     = "";
    let idusuario               = "";
    let alias                   = "";
    let pagoparcial             = "";

    Alumno.map(item => {
        idtutor                 = item.idtutor;
        apellidopaterno         = item.apellidopaterno.trim();
        apellidomaterno         = item.apellidomaterno.trim();
        nombres                 = item.nombres.trim();
        sexo                    = item.sexo.trim();
        fechanacimiento         = item.fechanacimiento.trim();
        estadonacimiento        = item.estadonacimiento.trim();
        discapacidad            = item.discapacidad.trim();
        discapacidaddescripcion = item.discapacidaddescripcion.trim();
        otra                    = item.otra.trim();
        aptitud                 = item.aptitud.trim();
        aptituddescripcion      = item.aptituddescripcion.trim();
        calle                   = item.calle.trim();
        numero                  = item.numero.trim();
        colonia                 = item.colonia.trim();
        municipio               = item.municipio.trim();
        codigopostal            = item.codigopostal;
        telefono                = item.telefono.trim();
        nivel                   = item.nivel.trim();
        nivel2                  = item.nivel2;
        grupo                   = item.grupo.trim();
        turno                   = item.turno.trim();
        nombretutor             = item.nombretutor.trim();
        correotutor             = item.correotutor.trim();
        ajuste                  = "0";
        enviarcorreo            = "NO";
        tipopago                = "";
        facturar                = "NO";
        rfc                     = "";
        idusuario               = sessionStorage.getItem('idusuario');
        alias                   = sessionStorage.getItem('alias');
        pagoparcial             =item.pagoparcial;
    })

    return {

        initialValues: {
            idtutor,
            apellidopaterno,
            apellidomaterno,
            nombres,
            sexo,
            fechanacimiento,
            estadonacimiento,
            discapacidad,
            discapacidaddescripcion,
            otra,
            aptitud,
            aptituddescripcion,
            calle,
            numero,
            colonia,
            municipio,
            codigopostal,
            telefono,
            nivel,
            nivel2,
            grupo,
            turno,
            nombretutor,
            ajuste,
            enviarcorreo,
            tipopago,
            correotutor,
            facturar,
            rfc,
            idusuario,
            alias,
            pagoparcial
        }
    };


    
}; //END MAPSTATETOPROPS

const arreglotutor = [];

class FormCobroAlumno extends Component {

    

    render() {

        return (
            <form onSubmit={this.props.handleSubmit}>

                <FormGroup row>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="enviarcorreo"
                                component={renderSelectField5}
                            >
                                <option value="" />
                                <option value={'SI'}>Enviar Correo a Tutor</option>
                                <option value={'NO'}>NO Enviar Correo a Tutor</option>
                            </Field>

                        </FormGroup>
                    </Col>


                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="tipopago"
                                component={renderSelectField6}
                            >
                                <option value="" />
                                <option value={'Transferencia Electrónica'}>Transferencia Electrónica</option>
                                <option value={'Depósito Ventanilla'}>Depósito Ventanilla</option>
                                <option value={'IEC'}>IEC</option>
                                <option value={'Cajero'}>Cajero</option>
                                <option value={'Tarjeta Débito'}>Tarjeta Débito</option>
                                <option value={'Tarjeta Crédito'}>Tarjeta Crédito</option>
                            </Field>

                        </FormGroup>
                    </Col>


                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="number"
                                name="ajuste"
                                component={renderField}
                                label="Ajuste :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="correotutor"
                                component={renderField}
                                label="Correo Tutor :"
                            />
                        </FormGroup>
                    </Col>


                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="facturar"
                                component={renderSelectField7}
                            >
                                <option value="" />
                                <option value={'NO'}>NO Requiero Facturar</option>
                                <option value={'SI'}>SI Requiero Facturar</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="rfc"
                                component={renderField}
                                label="RFC :"
                            />
                        </FormGroup>
                    </Col>


                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="idcicloescolar"
                                component={renderSelectField8}
                            >
                                <option value="" />
                                
                                <option value={'2'}>Ciclo Escolar 2021-2022</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="idusuario"
                                component={renderField}
                                label="ID SUARIO:" disabled
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="alias"
                                component={renderField}
                                label="ALIAS USUARIO:" disabled hidden
                            />
                        </FormGroup>
                    </Col>


                </FormGroup>


                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            {
                                
                                //console.log("javier-->" + JSON.stringify(this.props.initialValues))
                                //console.log("javier-->" + this.props.submitSucceeded)
                            }

                            {
                                !this.props.submitSucceeded ? (

                                    (this.props.initialValues.pagoparcial === "NO") ? (
                                        <Button
                                            color="dark"
                                            type="submit"
                                            disabled={this.props.submitSucceeded}

                                        >
                                            Procesar Pago
                                        </Button>
                                    ) : (
                                            <Button
                                                color="dark"
                                                type="submit"
                                                disabled={true}
                                            >
                                                Existen pagos parciales
                                            </Button>
                                            )

                                ) : (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )

                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }
}

FormCobroAlumno = reduxForm({
    form: "formCobroAlumno",
    validate,
    enableReinitialize: true,
})(FormCobroAlumno);
export default connect(mapStateToProps, null)(FormCobroAlumno);
